// extracted by mini-css-extract-plugin
export default {"desktopNav":"desktopNav__MGM1M","navLeft":"navLeft__MzNlN","navRight":"navRight__NTA5N","navLogoLink":"navLogoLink__NzAxM","navItems":"navItems__ZDExN","navItem":"navItem__MmQwZ"};